import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=fc240442&"
import script from "./UiButton.vue?vue&type=script&lang=js&"
export * from "./UiButton.vue?vue&type=script&lang=js&"
import style0 from "./UiButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports